export const LOCALSTORAGE_VAR = 'showEasterEgg';
export const LOCALSTORAGE_PARAMS_VAR = 'requestParams';

export const TEST_PG_QUERY_PATTERN = /testPg=(\w+)/;

export const BUTTON_TITLE_TEST_PAYMENT_OFF = 'Вкл.';
export const BUTTON_TITLE_TEST_PAYMENT_ON = 'Выкл.';
